import SlotCounter from "react-slot-counter";
interface StatDisplayProps {
  count: number | string;
  label: string;
  slotCounter?: boolean;
  animateOnVisible?: boolean;
}

export const StatDisplay = ({
  count,
  label,
  slotCounter = false,
  animateOnVisible = false,
}: StatDisplayProps) => (
  <div className="flex items-center gap-[6px]">
    <span className="tiny-mono-bold text-fg-base leading-none align-middle">
      {" "}
      {slotCounter ? (
        <SlotCounter value={count} animateOnVisible={animateOnVisible} />
      ) : (
        count
      )}
    </span>
    <span className="tiny-normal text-fg-muted leading-none align-middle">
      {label}
    </span>
  </div>
);
